// import { Tag } from '@blueprintjs/core'
// import React, { PureComponent } from 'react'
import { PureComponent } from 'react'

import './notification-badge.scss'

type Props = {
  value: number
}

export class NotificationBadge extends PureComponent<Props> {
  render() {
    // const { value } = this.props

    return null

    // return (
    //   <Tag className="notification-badge anim--notify" data-test="badge">
    //     {value}
    //   </Tag>
    // )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/notification-badge/notification-badge.tsx